import { Exercise } from 'src/app/models/winco/exercise.model';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModalBoxEvent, ModalBoxService } from 'modal-box';
import { EventManagerService } from 'event-manager';
import { CameraService } from 'src/app/services/camera.service';
import { NumberToTimePipe } from 'src/app/pipes/number-to-time.pipe';
import { EParameter } from 'src/app/enums/parameter.enum';

/**
 * Muestra una ventana de ejercicio
 */
@Component({
  selector: 'app-exercise-info-component',
  templateUrl: './exercise-info.component.html',
  styleUrls: ['./exercise-info.component.scss'],
})
export class ExerciseInfoComponent implements OnInit
{
  ModalBoxEvent = ModalBoxEvent;
  environment = environment;

  @Input() message: string;

  exercise:Exercise;
  penalties:string[];
  equipment:string[];

  constructor(private cameraService: CameraService,
              public modalBoxService:ModalBoxService,
              public eventManagerService: EventManagerService
  )
  {}

  /**
   * Se ejecuta la primera vez que se carga el componente
   */
  ngOnInit()
  {
    this.exercise = this.modalBoxService.config.data;
    this.equipment = new Array<string>();
    this.penalties = new Array<string>();

    if(this.exercise)
    {
      if(this.exercise.equipment)
        this.equipment = this.exercise.equipment.split('\n');

      if(this.exercise.penalties)
        this.penalties = this.exercise.penalties.split('\n');
    }
  }

  /**
   * Oculta el modal de informacion y guarda la variable que comprueba si se esta mostrando
   */
  hideModal () {
    this.cameraService.showingInfo = false
    this.modalBoxService.hide();
  }
}
